import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_EMAIL_TEMPLATES_FAIL = "GET_EMAIL_TEMPLATES_FAIL";

export interface GetEmailTemplatesFailAction extends Action {
  type: typeof GET_EMAIL_TEMPLATES_FAIL;
  organization: OrganizationKeyName;
}

export const getEmailTemplatesFailAction = (
  organization: OrganizationKeyName
): GetEmailTemplatesFailAction => ({
  type: GET_EMAIL_TEMPLATES_FAIL,
  organization,
});
